import React from 'react';
import "../styleFiles/ContactUs.css"


const ContactUs = () => {

    return(
        <>
            <section style={{"height":"75vh"}}>
                <h1 className='component-title'> Get Touch With Me Now ! </h1>
                <section className='Container'>
                    <div className='d-flex justify-content-evenly flex-wrap'>
                        <SkillItem src='/assets/LinkedIn.png' name='LinkedIn' link="https://www.linkedin.com/in/ahmed-osama-289bb0288"/>
                        <SkillItem src='/assets/Github.png' name='Github' link="https://github.com/Ahmed-Osama-Fawzy"/>
                        <SkillItem src='/assets/Gmail.png' name='Email' link="mailto:ahmd.osama2611@gmail.com"/>
                        <SkillItem src='/assets/WhatsApp.png' name='WhatsApp' link="https://wa.me/201115575342"/>
                        <SkillItem src='/assets/PhoneCall.png' name='Phone' link="tel:+20111557534"/>
                    </div>
                </section>
            </section>
        </>
    )
}

const SkillItem = ({ src, name, link }) => (
    <div className="text-center m-3 skill-item">
        <div> <a href={link}  target='_blank' rel="noreferrer"><img src={src} alt={name} height="50" width="50" /> </a></div>
        <div><span>{name}</span></div>
    </div>
);


export default ContactUs;